const en = {
  // Common
  appName: 'GatherUp',
  loading: 'Loading...',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  submit: 'Submit',
  sending: 'Sending...',
  saving: 'Saving...',
  error: 'Error',
  success: 'Success',
  invite: 'Invite',
  unknown: 'Unknown',
  you: 'you',
  tryAgain: 'Try Again',
  
  // Auth
  login: 'Login',
  signup: 'Sign Up',
  logout: 'Logout',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  forgotPassword: 'Forgot Password?',
  resetPassword: 'Reset Password',
  enterEmailAndPassword: 'Please enter both email and password',
  invalidCredentials: 'Invalid email or password',
  welcomeBack: 'Welcome back! Please enter your details',
  dontHaveAccount: 'Don\'t have an account?',
  loginRequired: 'You need to be logged in to create a party',
  goToLogin: 'Go to Login',
  
  // Navigation
  home: 'Home',
  profile: 'Profile',
  friends: 'Friends',
  createParty: 'Create Party',
  
  // Profile
  myProfile: 'My Profile',
  profileInfo: 'Profile Information',
  displayName: 'Display Name',
  bio: 'Bio',
  location: 'Location',
  security: 'Security',
  appearance: 'Appearance',
  language: 'Language',
  darkMode: 'Dark Mode',
  lightMode: 'Light Mode',
  editProfile: 'Edit Profile',
  saveChanges: 'Save Changes',
  profileUpdated: 'Profile updated successfully',
  
  // Parties
  party: 'Party',
  parties: 'Parties',
  partyDetails: 'Party Details',
  createNewParty: 'Create New Party',
  editParty: 'Edit Party',
  deleteParty: 'Delete Party',
  partyName: 'Party Name',
  partyDescription: 'Description',
  partyDate: 'Date',
  partyTime: 'Time',
  partyLocation: 'Location',
  partyHost: 'Host',
  hostedBy: 'Hosted by',
  organizedByYou: 'You',
  attendees: 'attendees',
  attendeesTitle: 'Attendees',
  noAttendees: 'No attendees yet',
  attending: 'Attending',
  notAttending: 'Not Attending',
  maybe: 'Maybe',
  rsvp: 'RSVP',
  rsvpNeeded: 'RSVP Needed',
  inviteGuests: 'Invite Guests',
  joinParty: 'Join Party',
  viewDetails: 'View Details',
  untitledParty: 'Untitled Party',
  noAddressProvided: 'No address provided',
  noLocationProvided: 'No location provided',
  noLocationCoordinates: 'No location coordinates provided',
  requestSent: 'Request Sent',
  youAreHosting: 'You are hosting',
  address: 'Address',
  fillAllFields: 'Please fill in all required fields and select a location on the map',
  mustBeLoggedIn: 'You must be logged in with a valid user ID to create a party',
  clickMapToSetLocation: 'Click on the map to set the party location',
  errorCreatingParty: 'Failed to create party',
  addressNotFound: 'Address not found. Please try a different address or click on the map.',
  errorGeocodingAddress: 'Failed to geocode address',
  partyCode: 'Party Code',
  clickToCopyPartyCode: 'Click to copy party code',
  partyCodeCopied: 'Party code copied to clipboard!',
  loadingPartyCode: 'Loading party code...',
  sharePartyCode: 'Share this code with friends to join your party:',
  copyPartyCode: 'Copy Party Code',
  failedToLoadPartyCode: 'Failed to load party code',
  generateCode: "Generate Code",
  partyCodeGenerated: "Party code generated!",
  errorGeneratingCode: "Error generating party code",
  noDateProvided: 'No date provided',
  noTimeProvided: 'No time provided',
  startingAt: 'Starting at',
  description: 'Description',
  yourLocation: 'Your Location',
  accuracy: 'Accuracy',
  meters: 'meters',
  
  // Items
  items: 'Items',
  itemsTitle: 'Who Brings What',
  addItem: 'Add Item',
  itemName: 'Item Name',
  broughtBy: 'Brought by',
  addingItem: 'Adding...',
  noItems: 'No items added yet',
  mustRSVPItems: 'You must RSVP as attending to add items',
  
  // Home
  welcomeMessage: 'Welcome to GatherUp! Create or join a party to get started.',
  yourParties: 'Your Parties',
  invitedParties: 'Parties You\'re Invited To',
  noHostedParties: 'You\'re not hosting any parties yet.',
  noInvitedParties: 'You haven\'t been invited to any parties yet.',
  host: 'Host',
  getStarted: 'Get Started',
  landingTitle: 'Plan Your Perfect Party',
  landingSubtitle: 'Create, organize, and manage your events with ease. Invite friends, track RSVPs, and make your gatherings unforgettable.',
  
  // Chat
  chat: 'Chat',
  partyChat: 'Party Chat',
  typeMessage: 'Type a message...',
  send: 'Send',
  noMessages: 'No messages yet. Start the conversation!',
  participants: 'participants', 
  mustRSVP: 'You must RSVP as attending to participate in the chat',
  
  // Friends
  addFriend: 'Add Friend',
  friendRequests: 'Friend Requests',
  pendingRequests: 'Pending Requests',
  yourFriends: 'Your Friends',
  noFriends: 'No friends yet',
  noPendingRequests: 'No pending requests',
  accept: 'Accept',
  decline: 'Decline',
  
  // Errors
  errorLoading: 'Error loading data',
  errorSaving: 'Error saving data',
  errorSendingMessage: 'Failed to send message',
  errorAddingItem: 'Failed to add item',
  errorInviting: 'Failed to invite user',
  errorRSVP: 'Failed to update RSVP status',
  errorUploadingAvatar: 'Failed to upload profile picture',
  
  
  // Check-in
  checkIn: "Check In",
  checkingIn: "Updating location...",
  updateLocation: "Update Location",
  locationUpdated: "Your location has been updated!",
  locationUpdateFailed: "Failed to update location",
  checkedInSuccess: "Successfully checked in!",
  alreadyCheckedIn: "You have already checked in to this party",
  checkedInFailed: "Failed to check in",
  checkedInHere: "checked in here",
  requestingLocation: "Please allow location access when prompted",
  locationPermissionDenied: "Location permission denied. Please enable location services to check in.",
  locationUnavailable: "Location information is unavailable. Please check your device settings.",
  locationTimeout: "Request for location timed out. Please try again.",
  locationError: "Could not get your location. Please try again.",
  locationAccess: "Location Access Required",
  locationAccessInstructions: "Please allow access to your location when prompted by your browser.",
  iOSInstructions: "On iOS, you may need to tap the button below or go to Settings > Privacy > Location Services",
  iOSSafariInstructions: "Safari on iOS requires special permission for location. Please follow the steps below.",
  locationTroubleshooting: "Location Access Troubleshooting",
  checkBrowserSettings: "Check that your browser has permission to access your location",
  refreshAndTryAgain: "Refresh the page and try again",
  iosGeneralSettings: "Go to Settings > Privacy > Location Services and ensure this app is allowed",
  safariSpecificSettings: "Go to Settings > Safari > Privacy & Security > Location Services and select 'Allow'",
  iOSSettingsInstructions: "If you still have issues, go to Settings > Privacy > Location Services and ensure the browser is allowed to access your location.",
  iOSLocationPrompt: "On iOS, you may need to allow location access in Settings",
  iOSLocationDenied: "Location access denied. On iOS, go to Settings > Privacy > Location Services",
  tryingAgain: "Trying again...",
  permissionGranted: "Location permission granted!",
  locationRequired: "Location Access Required",
  openSettings: "Open Settings",
  refreshPage: "Refresh Page",
  afterSettingsInstructions: "After enabling location in settings, return to this app and refresh the page",
  safariLocationInstructions: "You need to enable location services for Safari. Go to your device Settings > Privacy & Security > Location Services > Safari and select 'Allow While Using App'.",
  iosLocationInstructions: "You need to enable location services for this browser. Go to your device Settings > Privacy & Security > Location Services and find your browser in the list.",
  httpsRequired: "HTTPS Connection Required",
  httpsRequiredExplanation: "Location services require a secure (HTTPS) connection. You are currently using an insecure (HTTP) connection.",
  switchToHttps: "Switch to Secure Connection",
  
  // Error handling
  somethingWentWrong: 'Something went wrong',
  errorOccurred: 'An error occurred in the application.',
  goToHomepage: 'Go to Homepage',
}

export default en; 